import { render } from "./OrderConfirm.vue?vue&type=template&id=4e062445&scoped=true"
import script from "./OrderConfirm.vue?vue&type=script&lang=js"
export * from "./OrderConfirm.vue?vue&type=script&lang=js"

import "./OrderConfirm.vue?vue&type=style&index=0&id=4e062445&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e062445"]])

export default __exports__